// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";

const name = "volumetricLightingRenderVolumeVertexShader";
const shader = `#include<__decl__sceneVertex>
#include<__decl__meshVertex>
attribute vec3 position;
varying vec4 vWorldPos;void main(void) {vec4 worldPos=world*vec4(position,1.0);vWorldPos=worldPos;gl_Position=viewProjection*worldPos;}
`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("./ShadersInclude/sceneVertexDeclaration"),
    import("./ShadersInclude/sceneUboDeclaration"),
    import("./ShadersInclude/meshVertexDeclaration"),
    import("./ShadersInclude/meshUboDeclaration")
]));
/** @internal */
export const volumetricLightingRenderVolumeVertexShader = { name, shader };
